module.exports = "<wow-card-list show-header=\"true\">\r\n    <wow-search-list></wow-search-list>\r\n</wow-card-list>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/search/search-products-category-center-template.html
 ** module id = 994
 ** module chunks = 1
 **/